import GenericAction from '@Actions/generic-action';
import { Actions, Events } from '@Context/common/general/context';
import { getAuth } from 'firebase/auth';

export default class ReloadUser extends GenericAction {
  runAction() {
    this._disableLoaders = true;

    // Update Auth state always on firebase auth state changes
    const Action = async () => {
      try {
        const firebaseAuth = getAuth();
        let currentEmailVerified = firebaseAuth.currentUser.emailVerified;
        await firebaseAuth.currentUser.reload();
        this._dispatch({
          type: Actions.CoreActions.UpdateState,
          payload: {
            user: {
              emailVerified: firebaseAuth.currentUser.emailVerified,
            },
          },
        });

        // Trigger email verified event if change in state is detected against previous
        if(currentEmailVerified === false && firebaseAuth.currentUser.emailVerified === true) {
          Events.auth.userEmailVerified.emit();
        }
        super.onSuccess(firebaseAuth.currentUser);
        return Promise.resolve();
      } catch (error) {
        super.onError(error);
        return Promise.reject(error);
      }
    };
    Action();
  }
}
